import {
    SET_FREEZE_BLOCK_FILTERS,
    GET_FREEZE_BLOCK_REPORT,
    CLEAR_FREEZE_BLOCK_REPORT,
    SET_PACK_CODE_FILTERS,
    GET_PACK_CODE_REPORT,
    CLEAR_PACK_CODE_REPORT,
} from '../actions/actionTypes';

const INITIAL_STATE = {
    freezeBlockFilters: {
        startDate: null,
        endDate: null,
        queryByField: 'gigyaId',
        queryByValue: '',
        promotionType: '',
    },
    freezeBlockReport: [],
    totalCount: 0,
    hasSearched: false,
    page: 0,
    rowsPerPage: 10,
    packCodeFilters: {
        startDate: null,
        endDate: null,
        queryByField: 'gigyaId',
        queryByValue: '',
        eventType: '',
    },
    packCodeReport: [],
    packCodeTotalCount: 0,
    packCodeHasSearched: false,
};

const customerReportReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_FREEZE_BLOCK_FILTERS: {
            return {
                ...state,
                freezeBlockFilters: {
                    ...state.freezeBlockFilters,
                    ...action.filters,
                },
            };
        }
        case GET_FREEZE_BLOCK_REPORT: {
            return {
                ...state,
                freezeBlockReport: action.reportData,
                totalCount: action.totalCount,
                hasSearched: true,
            };
        }
        case CLEAR_FREEZE_BLOCK_REPORT: {
            return {
                ...state,
                freezeBlockFilters: INITIAL_STATE.freezeBlockFilters,
                freezeBlockReport: INITIAL_STATE.freezeBlockReport,
                totalCount: INITIAL_STATE.totalCount,
                hasSearched: INITIAL_STATE.hasSearched,
                page: INITIAL_STATE.page,
                rowsPerPage: INITIAL_STATE.rowsPerPage,
            };
        }
        case SET_PACK_CODE_FILTERS: {
            return {
                ...state,
                packCodeFilters: {
                    ...state.packCodeFilters,
                    ...action.filters,
                },
            };
        }
        case GET_PACK_CODE_REPORT: {
            return {
                ...state,
                packCodeReport: action.reportData,
                packCodeTotalCount: action.totalCount,
                packCodeHasSearched: true,
            };
        }
        case CLEAR_PACK_CODE_REPORT: {
            return {
                ...state,
                packCodeFilters: INITIAL_STATE.packCodeFilters,
                packCodeReport: INITIAL_STATE.packCodeReport,
                packCodeTotalCount: INITIAL_STATE.packCodeTotalCount,
                packCodeHasSearched: INITIAL_STATE.packCodeHasSearched,
            };
        }
        default: {
            return state;
        }
    }
};

export default customerReportReducer;
